import { Select } from '@material-ui/core';
import { Box, Button as MuiButton, Typography } from '@mui/material';
import styled from 'styled-components';

import { colors } from '../../../../theme';

export const TooltipTarget = styled.span`
    display: inline-block;
`;

export const selectMenuProps = {
    anchorOrigin: {
        vertical: 'bottom' as const,
        horizontal: 'left' as const
    },
    transformOrigin: {
        vertical: 'top' as const,
        horizontal: 'left' as const
    },
    getContentAnchorEl: null
};

export const StyledSelect = styled(Select)`
    && {
        min-width: 120px;
        font-size: 0.8rem;
        color: ${colors.blackRock};

        &:hover .MuiOutlinedInput-notchedOutline {
            border-color: ${colors.blackRock};
        }
    }
`;

export const dialogPaperProps = {
    style: {
        backgroundColor: colors.darkBlue,
        color: colors.white,
        padding: '20px',
        borderRadius: '8px',
        margin: '16px',
        maxWidth: '480px',
        position: 'relative' as const
    }
};

export const ModalTitle = styled(Typography)`
    && {
        text-align: center;
        font-weight: bold;
        color: ${colors.white};
        font-size: 20px;
        margin: 0 0 20px 0;
        padding: 0;
    }
`;

export const ModalContentText = styled(Typography)`
    && {
        font-size: 14px;
        color: ${colors.white};
        line-height: 1.5;
        text-align: center;
        margin: 0;
    }
`;

export const ModalActions = styled(Box)`
    display: flex;
    justify-content: center;
    gap: 10px;
    padding: 20px 0 0 0;
`;

export const CancelButton = styled(MuiButton)`
    && {
        padding: 10px 20px;
        font-size: 14px;
        font-weight: 500;
        color: ${colors.white};
        background-color: ${colors.blackRock};
        border-radius: 20px;
        min-width: 100px;
        text-transform: none;

        &:hover {
            background-color: ${colors.darkGray};
        }
    }
`;

export const ArchiveButton = styled(MuiButton)`
    && {
        padding: 10px 20px;
        font-size: 14px;
        font-weight: 500;
        color: ${colors.white};
        background-color: ${colors.lightningYellow};
        border-radius: 20px;
        min-width: 100px;
        text-transform: none;

        &:hover {
            background-color: ${colors.yellow60};
        }
    }
`;
